import { render, staticRenderFns } from "./UserForms.vue?vue&type=template&id=245f7f94&scoped=true&"
import script from "./UserForms.vue?vue&type=script&lang=js&"
export * from "./UserForms.vue?vue&type=script&lang=js&"
import style0 from "./UserForms.vue?vue&type=style&index=0&id=245f7f94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245f7f94",
  null
  
)

export default component.exports